import styled from '@emotion/styled';
import { Loader } from '@innovamat/glimmer-components';
import { useParams, useSearchParams } from 'react-router-dom';
import { ErrorPage } from '../../../navigation';
import { useTestReport } from '../../hooks/use-test-report';
import { TestReportViewer } from './components/test-report-viewer';

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const ErrorWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  padding: 24px;
`;

function TestReportView(): JSX.Element {
  const { testRoundId } = useParams();
  const [searchParams] = useSearchParams();
  const language = searchParams.get('language');

  const { pdfBase64, isLoading, isError, is404Error } = useTestReport({
    testRoundId: testRoundId || '',
    language: language || '',
  });

  if (!testRoundId || !language) {
    return (
      <ErrorWrapper>
        <ErrorPage errorType="NOT_FOUND" />
      </ErrorWrapper>
    );
  }

  if (isLoading) {
    return (
      <LoaderWrapper>
        <Loader size="lg" />
      </LoaderWrapper>
    );
  }

  if (isError || !pdfBase64) {
    return (
      <ErrorWrapper>
        <ErrorPage errorType={is404Error ? "NOT_FOUND" : "ERROR_500"} />
      </ErrorWrapper>
    );
  }

  return <TestReportViewer pdfBase64={pdfBase64} />;
}

export { TestReportView };
